/*Package importing*/
import React, { Component } from 'react';
import $ from 'jquery';
import Pdf from "react-to-pdf";

/*Components*/
import SectionHeadingStyle from '../elementsPreview/sectionHeadingStyle';
import SelectBox from '../formComponents/selectBox';
import ColorPicker from '../common/colorPicker';
import APILoader from '../../components/other/api-loader';
import NoDataFound from '../../components/other/nothing';

/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';
import APIGet from '../../services/apiCall/get';


/*Assets*/
import logo from '../../assets/images/logo.svg';

const ref = React.createRef();

class DetailInvoice extends Component {
  constructor(props){
    super(props);
    this.state = {
      colorOne: "",
      colorTwo: "",
      pickerOneID: "colorPick1",
      pickerTwoID: "colorPick2",
      category: null,
      styleType: null,
      data: null
    }
  }

  componentDidMount() {
    this.getData();

  }
  getData(){
    this.setState({ apiLoading: true});
    var url = devconfig.vendor+'invoice/detail';
    var data = JSON.stringify({
      "id" : parseInt(this.props.id)
    })
    APIPost(url,data).then(function(response){
      if(response.status == "ok"){
        this.setState({data: response.data,apiLoading: false});
      }
    }.bind(this))
  }


  selectheading(tempType, tempClass){
    $(".e-demo-heading-wrap").removeClass("e-active");
    $(tempClass).addClass("e-active");

    this.setState({styleType: tempType});
  }

  pickerOneColorChange(tempColor){
    this.setState({colorOne: tempColor});
  }

  pickerTwoColorChange(tempColor){
    this.setState({colorTwo: tempColor});
  }

  triggerClick(tempItem, tempLoader){
    $(tempItem).trigger('click');
    this.setState({showUploadLoader: tempLoader});
  }

  selectChange = async (category) => {
    await this.setState({category: category});
  }

  submit(){
    var tempArry = {
      "content": this.state.category.label,
      "type": this.state.styleType,
      "font_color": this.state.colorOne,
      "bg_color": this.state.colorTwo,
      "category": this.state.category.value
    };

    this.props.success(tempArry);
  }

  render() {
    var data = this.state.data;

    var tempHeading=[
      { "type": 1, "content": "Heading style - 1", font_color: "#000", bg_color: "#1200DE"},
      { "type": 2, "content": "Heading style - 2", font_color: "#000", bg_color: "#F9DB3F"},
      { "type": 3, "content": "Heading style - 3", font_color: "#000", bg_color: "#1CD6A9"},
      { "type": 4, "content": "Heading style - 4", font_color: "#000", bg_color: "#F64A7C"},
      { "type": 5, "content": "Heading style - 5", font_color: "#000", bg_color: "#EA4747"},
      { "type": 6, "content": "Heading style - 6", font_color: "#000", bg_color: "#ABB6DF"},
      { "type": 7, "content": "Heading style - 7", font_color: "#000", bg_color: "#F64A7C"},
      { "type": 8, "content": "Heading style - 8", font_color: "#000", bg_color: "#20B7EC"},
      { "type": 9, "content": "Heading style - 9", font_color: "#000", bg_color: "#FF9B21"},
      { "type": 10, "content": "Heading style - 10", font_color: "#000", bg_color: "#5FE70E"},
      { "type": 11, "content": "Heading style - 11", font_color: "#000", bg_color: "#1200DE"},
      { "type": 12, "content": "Heading style - 12", font_color: "#000", bg_color: "#F0CA42"},
      { "type": 13, "content": "Heading style - 13", font_color: "#000", bg_color: "#FF9CBE"},
      { "type": 14, "content": "Heading style - 14", font_color: "#000", bg_color: "#EBF4B5"},
      { "type": 15, "content": "Heading style - 15", font_color: "#000", bg_color: "#D9D9D9"},
      { "type": 16, "content": "Heading style - 16", font_color: "#000", bg_color: "#FF9B21"},
      { "type": 17, "content": "Heading style - 17", font_color: "#000", bg_color: "#E9CA2B"},
      { "type": 18, "content": "Heading style - 18", font_color: "#000", bg_color: "#D53578"},
      { "type": 19, "content": "Heading style - 19", font_color: "#000", bg_color: "#C38448"},
      { "type": 20, "content": "Heading style - 20", font_color: "#000", bg_color: "#E9CA2B"},
    ]

    const filterBy = [
      { value: 1, label: 'Clothing' },
      { value: 2, label: 'Fashion' },
      { value: 3, label: 'Beauty & personal care' },
      { value: 4, label: 'Wedding special' },
      { value: 5, label: 'Footwear' },
      { value: 6, label: 'Jewellery' },
      { value: 7, label: 'Electronics' },
      { value: 8, label: 'Travel' },
      { value: 9, label: 'Food & beverages' },
      { value: 10, label: 'Automobiles' },
      { value: 11, label: 'Mobiles & laptops' },
      { value: 12, label: 'Luxury shopping' },
    ]


    var tempIDSelectOne = "#"+this.state.pickerOneID;
    var tempIDSelectTwo = "#"+this.state.pickerTwoID;
    var tempColorOne = { background: this.state.colorOne };
    var tempColorTwo = { background: this.state.colorTwo };


    return (
      <div className="modal fade e-detail-invoice-wrap" id={this.props.selector} tabIndex="-1" role="dialog" aria-labelledby="invoiceDetailModalLabel" aria-hidden="true">
        <div className="modal-dialog"  role="document">
         {
            this.state.data ?
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body pb-5" ref={ref}>
                  <div className="row mb-4">
                    <div className="col-lg-8">
                      <img src={logo} alt="truekhoj logo"/>
                    </div>
                    <div className="col-lg-4">
                      <h5 className="mb-3">Paid Invoice</h5>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <p className="mb-1">{data.admin_data.company}</p>
                      <p className="mb-1 ">{data.admin_data.address}</p>
                      <p>GST: {data.admin_data.gst_no}</p>
                    </div>
                    <div className="col-lg-4 offset-lg-2">
                      <p className="mb-0"><b>Invoice no:</b> {data.invoice_no}</p>
                      <p><b>Invoice date:</b> {data.purchased_on}</p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <h4>Billing to:</h4>
                      <p className="mb-1">{data.vendor_data.company}</p>
                      <p className="mb-1">{data.vendor_data.address}</p>
                      <p>GST: {data.vendor_data.gst_no}</p>
                    </div>
                  </div>

                  <div className="row mt-5 pb-2 e-price-table-header">
                    <div className="col-lg-6">
                      <h4 className="m-0">Plan</h4>
                    </div>
                    <div className="col-lg-2">
                      <h4 className="m-0">Quantity</h4>
                    </div>
                    <div className="col-lg-2">
                      <h4 className="m-0">Price</h4>
                    </div>
                    <div className="col-lg-2">
                      <h4 className="m-0">Amount</h4>
                    </div>
                  </div>

                  <div className="row mt-4 e-price-table-item">
                    <div className="col-lg-6">
                      <p>{data.type} - {data.plan_name}</p>
                    </div>
                    <div className="col-lg-2">
                      <p>{data.quantity}</p>
                    </div>
                    <div className="col-lg-2">
                      <p>{data.amount}</p>
                    </div>
                    <div className="col-lg-2">
                      <p>{data.amount}</p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="offset-lg-8 col-lg-4 mt-3">
                      <div className="row">
                        <div className="col-lg-6">
                          <h6>Subtotal:</h6>
                        </div>
                        <div className="col-lg-6">
                          <p>{data.amount}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <h6>IGST:</h6>
                        </div>
                        <div className="col-lg-6">
                          <p>{data.gst}</p>
                        </div>
                      </div>
                      <div className="row e-price-table-total pt-3 pb-5">
                        <div className="col-lg-6">
                          <h6>Total</h6>
                        </div>
                        <div className="col-lg-6">
                          <p>{data.total}</p>
                        </div>
                      </div>
                      <span className="e-price-table-fully-paid">Fully Paid</span>
                    </div>


                  </div>

                </div>
                <div className="modal-footer">
                {/*<Pdf targetRef={ref} filename="Invoice.pdf">
                  {({ toPdf }) => <button className="e-s-btn" onClick={toPdf}>Download as pdf</button>}
                </Pdf>*/}

                  {/*

                  <span className="e-s-link-txt mr-4" data-dismiss="modal">Cancel</span>
                  {
                    this.state.category && this.state.styleType && this.state.colorOne.length && this.state.colorTwo.length  ?
                      <button type="submit" className="e-s-btn" value="Submit" data-dismiss="modal" onClick={this.submit.bind(this)}>Submit</button>
                    :
                      <button type="submit" className="e-s-btn e-inactive" value="Submit" >Submit</button>
                  }

                */}

                </div>
              </div>
            :
              null
          }
        </div>
      </div>
    );
  }
}

export default DetailInvoice;
